// extracted by mini-css-extract-plugin
export default {"Button":"Button_Button__joGUd","main":"Button_main__Uy7vu","secondary":"Button_secondary__rXTUf"};